import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  // FormGroup,
  // Button,
  // Label,
  // Input,
  Container,
  // CustomInput,
  // InputGroup,
  // Form,
  // InputGroupAddon,
} from "reactstrap";
import { Link } from "react-router-dom";
// import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
// import avatar2 from "../../assets/images/users/avatar-2.jpg";

import { connect } from "react-redux";
import "./reports.scss";

import {
  getReportsMenu,
  // add_menu,
  // delete_menu,
  // put_menu
} from "../../store/Reports/actions";
class ReportsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.getReportsMenu();
  }
  render() {
   
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <h3 className="card-title-18 pt-2">Reports Dashboard</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={12}>
                    {/* <h3 className="card-title-15 pt-2">Company</h3> */}
                    {/* <hr className="my-3" /> */}
                  </Col>
                  <Col md={12}>
                    <div className="Report-dashboard">
                      <div className="Report-dashboard-menu">
                        <Row className="mb-2">
                          {this.props.reportMenu.menuitems &&
                            this.props.reportMenu.menuitems
                              .sort((a, b) =>
                                a.sequence > b.sequence ? 1 : -1
                              )
                              .map((report, key) => (
                                <Col md={4} key={key}>
                                  <Link to={report.link}>
                                    <div className="Report-dashboard-item mb-2 ">
                                      <div className="title-box d-inline-block">
                                        <span className="mt-4">
                                          {report.title}
                                        </span>
                                      </div>

                                      <div className="view-box float-right">
                                        <Link
                                          to={report.link}
                                          className="waves-effect ml-2"
                                        >
                                          <i className="ri-menu-fill"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </Link>
                                </Col>
                              ))}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { reportMenu } = state.reports;
  return { reportMenu };
};

export default withRouter(
  connect(mapStatetoProps, {
    getReportsMenu,
  })(ReportsDashboard)
);
